import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';

import CasillaIncid from './../../../img/casillaIncidentes.png';
import CasillaNoInstalada from './../../../img/casillaNoInstalada.png';
import IncidentesLista from './../../../img/incidentesLista.png';
import TiempoCasilla from './../../../img/casillaTiempo.png';
import AccionesComunes from '../../AccionesComunes';

class Incidentes extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("jornadaElec");
        activeMenu.className += " active";
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Jornada Electoral</span>
                        <span>Incidentes</span>
                    </small>
                </div>
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">Incidentes</h1>
                    <p className="centrar">
                        Son aquellas situaciones que interfieren con el pleno desarrollo de la Jornada Electoral. Se encuentran clasificados según la etapa de la Jornada Electoral en que pueden suceder.
                    </p>
                </div>
                <div className="row bordes">
                    <div className="col-md-6 centrar-vertical">
                        <p>
                            Se identifican por un código alfanumérico consecutivo. Para el Proceso Electoral Local 2019 -2020 se tiene un listado de 37 incidentes diferentes.
                        </p>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={CasillaIncid} alt="Incidentes de casilla" />
                    </div>
                </div>
                <div className="row bordes">
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={CasillaNoInstalada} alt="Casilla no instalada" />
                    </div>
                    <div className="col-md-6 centrar-vertical">
                        <p>
                            El primer incidente y el más grave, es el: incidente <strong><i>1. Casilla no instalada</i></strong>.
                        </p>
                    </div>
                </div>
                <div className="row bordes">
                    <div className="col-md-6 centrar-vertical">
                        <p>
                            Dependiendo del tipo de incidente, este puede tener o no la posibilidad de solucionarse. Para conocer el detalle consulta el <Link to="./CatalogoIncidentes">catálogo de incidentes</Link>.
                        </p>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={IncidentesLista} alt="Incidentes de casilla" />
                    </div>
                </div>
                <div className="row bordes">
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={TiempoCasilla} alt="Casilla de día a noche" />
                    </div>
                    <div className="col-md-6 centrar-vertical">
                        <p>
                            Los incidentes pueden ser reportados en cualquier momento durante la jornada electoral.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Incidentes;